<template>
  <el-radio-group
    v-if="isDesktop"
    v-model="value"
    class="desktop"
    @update:modelValue="update"
  >
    <el-radio-button
      v-for="typeLabel in types"
      :key="typeLabel.type_id"
      :value="typeLabel.type_id"
    >
      {{ typeLabel.label }}
    </el-radio-button>
  </el-radio-group>
  <el-select v-else v-model="value" @update:modelValue="update">
    <el-option
      v-for="typeLabel in types"
      :key="typeLabel.type_id"
      :label="typeLabel.label"
      :value="typeLabel.type_id"
    >
      {{ typeLabel.label }}
    </el-option>
  </el-select>
</template>

<script lang="ts">
import { defineComponent, computed, ref, watch } from 'vue'
import { FlatDealTypeLabels } from '@/api/types'
import useResize from '@/hooks/useResize'

export default defineComponent({
  name: 'FlatDealTypeSelector',
  props: {
    modelValue: {
      type: Number,
      default: undefined
    }
  },
  setup(props, context) {
    const value = ref(props.modelValue)

    const update = (newValue: any) => {
      context.emit('update:modelValue', newValue)
    }

    const types = computed(() => {
      return FlatDealTypeLabels
    })

    const { isDesktop } = useResize()

    watch(
      () => props.modelValue,
      (newVal) => {
        value.value = newVal
      }
    )

    return { update, isDesktop, types, value }
  }
})
</script>

<style lang="scss" scoped>
.el-select {
  width: 100%;
}
</style>
